import { createAction } from 'redux-actions';

import { ExchangePassengersState } from '../types';

export const SET_PASSENGERS = 'EXCHANGE/SET_PASSENGERS';
export const SET_PASSENGER_SELECT = 'EXCHANGE/SET_PASSENGER_SELECT';

export interface SetPassengerSelectPayload {
	id: string | string[];
	selected: boolean;
}

export const setPassengers = createAction<ExchangePassengersState>(SET_PASSENGERS);

export type SetPassengersAction = ReturnType<typeof setPassengers>;

export const setPassengerSelect = createAction<SetPassengerSelectPayload>(SET_PASSENGER_SELECT);

export type SetPassengerSelectAction = ReturnType<typeof setPassengerSelect>;
